const state = {
    sinConexion: false,
    webCam: false,
    testing: true
};

const mutations = {
  'SIN_CONEXION'(state, sinConexion) {
    state.sinConexion = sinConexion;
  },
  'WEBCAM'(state, webCam) {
    state.webCam = webCam;
  },
};

const actions = {
  setSinConexion ( { commit }, sinConexion ) {
    commit('SIN_CONEXION', sinConexion);
  },
  setWebCam ( { commit }, webCam ) {
    commit('WEBCAM', webCam);
  },
};

const getters = {
  sinConexion(state) {
    return state.sinConexion;
  },
  webCam(state) {
    return state.webCam;
  },
  testing(state) {
    return state.testing;
  },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/settings.js